export enum IncidenceAffair {
  DRIVER_APP = 'DRIVER_APP',
  ROADMAP = 'ROADMAP',
  ROUTE = 'ROUTE',
  PAX = 'PAX',
  VEHICLE = 'VEHICLE',
  DELAY = 'DELAY',
  ACCIDENT = 'ACCIDENT',
  FULL_BUS = 'FULL_BUS',
  EMERGENCY = 'EMERGENCY',
  OTHERS = 'OTHERS'
}
